export default {
  showError(response) {
    if (response) {
      //put and patch with message are not considered
      // api from excel are not considered
      if (!response.data.Message) {
        if (response.status == 200 || response.status == 204) {
          if (response.config.method !== "get") {

            Swal.fire({
              position: "center-center",
              type: "success",
              text: "عملیات با موفقیت انجام شد.",
              showConfirmButton: false,
              timer: 4000,
            });
          }
        } else {
          if (
            response.status == 500 ||
            response.status == 502 ||
            response.status == 503
          ) {
            Swal.fire({
              position: "center-center",
              type: "error",
              text: "لطفا با ادمین سیستم تماس بگیرید.",
              showConfirmButton: false,
              timer: 4000,
            });
          } else {
            Swal.fire({
              position: "center-center",
              type: "error",
              text: "خطای سیستمی - کد خطا : " + response.status,
              showConfirmButton: false,
              timer: 4000,
            });
          }
        }
      } else {
        Swal.fire({
          position: "center-center",
          type: "error",
          text: response.data.Message,
          showConfirmButton: true,
        });
      }
    }
  },
};
import Swal from "sweetalert2/dist/sweetalert2.js";
